"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = InfoOutline;
var _InfoOutline = require("@adobe/react-spectrum-workflow/dist/InfoOutline.js");
var _icon = require("@react-spectrum/icon");
var _react = _interopRequireDefault(require("react"));
function InfoOutline(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_InfoOutline.A4uInfoOutline, null));
}